import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  tab: {
    flex: 1,
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0px 16px",
    textAlign: "center",
    cursor: "pointer",
    transition: "background-color 0.3s",
    userSelect: "none",
    backgroundColor: "transparent",
    borderRadius: "3px",
    color: "#0C0E29",
    fontFamily: "Lato, sans-serif",
    fontSize: "14px",
    whiteSpace: "nowrap",
  },
  selected: {
    backgroundColor: "#fff",
  },
});

const Tab = ({ children, selected, onClick, ...props }) => {
  const classes = useStyles();

  return (
    <div className={`${classes.tab} ${selected ? classes.selected : ""}`} onClick={onClick} {...props}>
      {children}
    </div>
  );
};

export default Tab;
